import { merge, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import * as BulkPurchaseActions from '../bulk/purchase/bulk.purchase.actions';
import { waitForEndOfCostReview } from '../bulk/purchase/bulk.purchase.cost-review.observables';

import * as Actions from './csw.actions';

export const runNowAndRetryAfterCostReview = ({ action$ }) => {
  return merge(
    timer(0),
    waitForEndOfCostReview(action$).pipe(
      takeUntil(action$.pipe(ofType(Actions.CSW_CREATE_LABEL_SUCCESS, BulkPurchaseActions.BULK_PURCHASE_COST_REVIEW_CANCEL))),
    ),
  );
};
